<template>
  <div class="email-login">
    <h1 v-t.preserve="'auth.email.title'" />
    <h2 v-t.preserve="'auth.email.subtitle'" />

    <form class="input-container card card--rounded" @submit.prevent="submit" novalidate autocomplete="off">
      <pk-input v-model="email" :placeholder="$t('auth.email.placeholder.email')" type="email" :error="$v.email.$error" autofocus />
      <pk-input v-model="password" :placeholder="$t('auth.email.placeholder.password')" type="password" :error="$v.password.$error" />
      <div class="info">
        <error-text :active="!!errorCode || !!$v.$error">
          <span v-if="errorCode === 400" v-t.preserve="'auth.email.error.invalidRequest'" />
          <span v-else-if="errorCode === 403" v-t.preserve="'auth.email.error.wrongCredentials'" />
          <span v-else-if="!!errorCode" v-t.preserve="'auth.email.error.generic'" />
          <span v-else-if="$v.email.$error" v-t.preserve="'auth.email.error.email'" />
          <span v-else-if="$v.password.$error" v-t.preserve="'auth.email.error.password'" />
        </error-text>
      </div>
      <btn flat :loading="loading" submit>{{ $t('auth.email.signIn') }}</btn>
      <a @click.prevent="$emit('changeAuthType', 'forgot', { email })" id="checkout-cadastro-cta-enviar-recuperacao-senha">
        {{ $t('auth.email.forgotPassword') }}
      </a>

      <div class="login-types">
        <div v-if="countryCode === 'US'">
          <hr />
          <span v-t.preserve="'auth.email.signInMethodsSeparator'" />
          <hr />
        </div>
<!--  <btn @click="() => changeLoginType('phone')" class="phone integration-btn">-->
<!--    <phone-icon class="icon" />-->
<!--    Connect with your phone number-->
<!--  </btn>-->
<!--  <facebook-integration-btn login @authenticated="$emit('authenticated')" />-->
        <btn flat @click="$emit('changeAuthType', 'playphone')" class="playphone integration-btn" v-if="countryCode === 'US'">
          <playphone-icon class="icon large" />
          {{ $t('auth.email.playphoneRouter') }}
        </btn>
        <!-- <apple-integration-btn login /> -->
        <div class="note"><alert-icon :title="''" /> <div class="note-text">{{ $t('auth.email.note') }}</div></div>
      </div>
    </form>

  </div>
</template>

<script>
import { mapState } from 'vuex'
import { required, minLength, email } from 'vuelidate/lib/validators'
import { AuthenticationPlatform } from '@/api/peanutbutter'
import authenticationService from '@/js/AuthenticationService'
import formSubmit from '@/js/mixins/formSubmit'

export default {
  name: 'email-login',
  mixins: [formSubmit('login')],
  data: () => ({
    email: '',
    password: ''
  }),
  validations: {
    email: { required, email },
    password: { required, minLength: minLength(6) }
  },
  computed: mapState({ countryCode: state => state.window.countryCode }),
  methods: {
    async login() {
      await authenticationService.signIn({
        signInParameters: {
          authenticationPlatform: AuthenticationPlatform.EMAIL,
          credentials: {
            email: this.email,
            password: this.password
          }
        }
      })

      this.$emit('authenticated')
    }
  },
  async created() {
    if (this.$route.params.email) {
      this.email = this.$route.params.email
    }
  }
}
</script>

<style lang="scss" scoped>
.email-login {
  .input-container {
    & > .info {
      display: inline-flex;
      justify-content: flex-end;
    }
    >.btn {
      margin: 2rem 0;
    }
    >a {
      display: inline-block;
      white-space: nowrap;
      margin-bottom: 2rem;
      text-align: center;
    }

    .login-types {
      display: flex;
      flex-direction: column;
      background-color: #F7F7F7;
      margin: 0 -3rem -2em -3rem;
      padding: 0 3rem 2rem;
      border-bottom-left-radius: 24px;
      border-bottom-right-radius: 24px;
      & > div {
        display: flex;
        margin: 2rem 0;
        span {
          text-align: center;
          font-weight: 800;
          margin: 0 10px;
          color: #606568; // secondary
        }
        hr {
          border: 0;
          border-bottom: 1px solid #606568;
          height: 1px;
          width: 100%;
        }
      }
      .phone {
        background: linear-gradient(180deg, #40DA6B 0%, #00BC8F 100%);
      }

      .note {
        margin: 30px 0 0 0;
        .note-text {
          margin: 0px 0 0 10px;
          font-size: 1.3em;
        }
        label {
          position: relative;
          transform: translateY(25%);
        }
      }

      .playphone {
        background: linear-gradient(180deg, #4CD3F5 0%, #00AEFF 100%);

        .icon {
          margin-top: 1px;
        }
      }
    }
  }

  @media screen and (min-width: 1200px) {
    .input-container {
      & > .btn {
        margin-bottom: 16px;
      }

      & > span {
        margin-bottom: 16px;
      }
    }
  }
}
</style>
